import { Columns } from '@/components/table/types';
import { WhiteUser } from '@api/plc';
import styles from './style.module.styl';

export const whiteListColumns: Columns<WhiteUser>[] = [
    {
        label: '全部成员',
        render: ({ row }) => (
            <div class={styles.content}>
                <img class={styles.avatar} src={row.userHeadPic} alt="" />
                <div class={styles.name}>{row.userName}</div>
            </div>
        ),
    },
    {
        label: '快手ID',
        prop: 'uid',
    },
];
